import { useCallback, useEffect, useState } from 'react';
// @mui
import Container from '@mui/material/Container';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
// routes
import { paths } from 'src/routes/paths';
// _mock
// components
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import Iconify from 'src/components/iconify';
import { useSettingsContext } from 'src/components/settings';
//
import { useLocation } from 'react-router-dom';
import { UserProfileView } from 'src/sections/user/view';
import AccountChangePassword from '../account-change-password';
import AccountGeneral from '../account-general';
import DeleteAccount from '../delete-account';
import { PLATFORM_ACCESS, ROLES, USER_TYPE_SHOPADMIN, USER_TYPE_SUPER_ADMIN } from 'src/config-global';
import { useMockedUser } from 'src/hooks/use-mocked-user';
import AccountCompany from '../account-company';

// ----------------------------------------------------------------------



// ----------------------------------------------------------------------

export default function AccountView() {

  const { state } = useLocation();

  const isEditCompany = state?.isEditCompany || false;

  const settings = useSettingsContext();

  const { user } = useMockedUser();

  const isAdmin = user?.user_type === USER_TYPE_SUPER_ADMIN;
  const view_access = user?.role === ROLES?.VIEW;
  const platform_access = user?.platform_access || [];
  const isCustomerHub = platform_access.includes(PLATFORM_ACCESS.CUSTOMER_HUB);
  const isShopAdmin = user?.user_type === USER_TYPE_SHOPADMIN;

  const TABS = [
    {
      value: 'profile',
      label: 'Profile',
      icon: <Iconify icon="solar:user-id-bold" width={24} />,
    },
    {
      value: 'editProfile',
      label: 'Edit Profile',
      icon: <Iconify icon="fluent:edit-12-filled" width={24} />,
    },

    {
      value: 'security',
      label: 'Security',
      icon: <Iconify icon="ic:round-vpn-key" width={24} />,
    },
    (!isAdmin && {
      value: 'deleteAccount',
      label: 'Delete Account',
      icon: <Iconify icon="material-symbols:delete" width={24} />,
    }),
    (
      !isAdmin && !view_access && !isShopAdmin &&
      {
        value: 'editCompany',
        label: 'Edit Company',
        icon: <Iconify icon="line-md:edit" width={24} />,
      }
    )
  ];



  const [currentTab, setCurrentTab] = useState('profile');

  const handleChangeTab = useCallback((event, newValue) => {
    setCurrentTab(newValue);
  }, []);

  useEffect(() => {
    if (state?.tab) {
      setCurrentTab(state.tab);
    }
  }, [state])

  useEffect(() => {
    if (isEditCompany) {
      setCurrentTab('editCompany');
    }
  }, [state])

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Account"
        links={[
          ...(isCustomerHub || isAdmin || isShopAdmin ? [{ name: 'Dashboard', href: isAdmin ? paths.superAdminDashboard.root : isShopAdmin ? paths.shopAdminDashboard.root : paths.dashboard.root }] : []),
          { name: 'Account', href: paths.dashboard.account },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <Tabs
        value={currentTab}
        onChange={handleChangeTab}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      >
        {TABS.map((tab) => (
          <Tab key={tab.value} label={tab.label} icon={tab.icon} value={tab.value} />
        ))}
      </Tabs>
      {currentTab === 'profile' && <UserProfileView />}

      {currentTab === 'editProfile' && <AccountGeneral />}

      {currentTab === 'security' && <AccountChangePassword />}

      {currentTab === 'deleteAccount' && <DeleteAccount />}

      {currentTab === 'editCompany' && <AccountCompany />}


    </Container>
  );
}
